/* Step 12 add-on G (lane GA) — small shared helpers (texts: lib/i18n/2150_s12f2_fixes.js).
   G5: the W9 source kind is always shown by its label, never by its raw key ("cutoff"); a kind with no label reads "Worksheet".
   G1 / G3 / G4: the detail an Audit Trail row of this add-on shows next to its action. */

// Every source kind a misstatement row is written with (backend misstatements_bridge.send_to_misstatements callers and the
// W9 manual entry). The guard tests (S12F2Fixes.test.js, backend test_step12_f2_fixes.py) keep this list and the labels whole.
export const W9_SOURCE_KINDS = [
  "cutoff", "cutoff_post_year_end", "unrecorded_liability", "opening_balance", "manual", "aging", "related_party", "completeness",
  "estimate", "observation", "discrepancy", "sample_projection", "w17_7",
];

export function sourceKindLabel(t, kind) {
  if (!kind) return "—";
  const k = `w9.sourceLabels.${kind}`;
  const v = t(k);
  return (typeof v === "string" && v && v !== k) ? v : t("w9.sourceOther");
}

function opinionText(t, code) {
  const c = String(code || "").trim().toLowerCase();
  if (!c) return t("s12f2.op.blank");
  const k = `s11c3Op.opinion.${c}`;
  const v = t(k);
  return (typeof v === "string" && v && v !== k) ? v : String(code);
}

/** The text after an Audit Trail row's action label for the rows of this add-on ("" for every other row). */
export function auditActionDetail(t, row) {
  const d = (row && row.details) || {};
  switch (row && row.action) {
    case "opinion_read_from_w10":
      return t("s12f2.audit.was").replace("{was}", opinionText(t, d.from));
    case "reporting_framework_set":
      return t("s12f2.audit.framework").replace("{fw}", t(d.to === "sme" ? "engSettings.rfSme" : "engSettings.rfFull"));
    case "misstatement_rows_unlinked":
    case "misstatement_rows_relinked":
      return t("s12f2.audit.rows").replace("{n}", String(d.count ?? 0));
    default:
      return "";
  }
}

// Step 12 add-on G2 (owner, F2 Q2): 305(a) / 309(a) cite "ISQM 2.24(b), 27 — where an engagement quality review is required";
// the forms library is English, so the screen puts the Arabic words in on an Arabic screen (the reference itself is unchanged).
export const EQR_REQUIRED_EN = "where an engagement quality review is required";
export function refText(t, ref) {
  const s = String(ref || "");
  if (!s.includes(EQR_REQUIRED_EN)) return s;
  const w = t("s12f2.isqm.eqrRequired");
  return (typeof w === "string" && w && w !== "s12f2.isqm.eqrRequired") ? s.replace(EQR_REQUIRED_EN, w) : s;
}
